export default {
    prev: "Show previous",
    next: "Show next",
    disabled: "(disabled)"
}